<template>
    <div class="xcard"> 

        <v-btn small class="mx-4" @click="$router.back()" color="info" tile outlined> 
            <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras 
        </v-btn>
        <h4 class="text-center mt-0">Edicion de datos personales</h4>

        <v-progress-linear indeterminate class="mb-3" color="purple" v-if="loading" />
        <v-row>
            <v-col cols="12" sm="6">
                <p class="mb-0"> <b>Documento:</b> {{ input.num_doc }} {{ departamento_sel?departamento_sel.extension:'' }} </p>
                <p class="mb-0"> <b>Apellido 1:</b> {{ user.pri_apellido }} </p>
                <p class="mb-3"> <b>Apellido 2:</b> {{ user.seg_apellido }} </p>
            </v-col>
        </v-row>
        <v-row no-gutters gutter-col-2>
            <v-col cols="12" sm="4">
                <v-text-field v-model.trim="input.nombres" label="Nombres:" outlined dense/>
            </v-col>
            <v-col cols="12" sm="4" class="pl-1">
                <v-combobox :items="departamentos" v-model="departamento_sel" :disabled="onlyread_ci" label="Departamento (extension CI):" outlined dense return-object clearable item-text="nombre"/>
            </v-col>
            <v-col cols="12" sm="4" class="pl-1">
                <v-combobox :items="paises" v-model="pais_sel" label="Nacionalidad:" outlined dense return-object item-text="nombre"/>
            </v-col>
            <v-col cols="12" sm="8">
                <v-combobox :items="instituciones" v-model="institucion_sel" label="Institucion de egreso:" outlined dense return-object clearable item-text="label"/>
            </v-col>
            <v-col cols="12" sm="4" class="pl-1">
                <v-combobox :items="grados" v-model="grado_sel" label="Grado academico:" outlined dense multiple return-object item-text="nombre"/>
            </v-col> 

            <v-col cols="12" sm="4" class="">
                <vue-tel-input v-model="input.telefono1"></vue-tel-input>
                <!-- <v-text-field v-model.trim="input.telefono1" label="Telefono:" outlined dense/> -->
            </v-col>
            <v-col cols="12" sm="4" class="pl-1">
                <v-text-field v-model.trim="input.email" label="Correo:" outlined dense/>
            </v-col>
            <v-col cols="12" sm="4" class="pl-1">
                <v-select :items="est_civils" v-model="est_civil_sel" label="Estado Civil:" outlined dense return-object item-text="n"/>
            </v-col>

            <v-col cols="12" sm="4">
                <v-combobox :items="profesiones" v-model="profesiones_sel" label="Profesiones:" outlined multiple chips clearable return-object item-text="nombre"/>
            </v-col>
            <v-col cols="12" sm="8" class="pl-1">
                <v-text-field v-model.trim="input.domicilio" label="Domicilio:" outlined dense/>
            </v-col> 
        </v-row>
        <v-row class="justify-center">
            <v-btn tile dark color="green darken-2" :disabled="loading" @click="guardar()">Guardar</v-btn>
        </v-row>
    </div>
  </template>
  
  <script>
  import PersonService from './personService'

  export default {
    data(){
      return{
        onlyread_ci: false,
        loading: false,
        user_id: null, 
        personService: new PersonService(),
        instituciones: [],
        profesiones: [],
        departamentos: [],
        paises: [],
        profesiones_sel:[],
        grados:[],
        est_civils:[{id:'S',n:'Soltero'},{id:'C',n:'Casado'},{id:'V',n:'Viudo'},{id:'D',n:'Divorciado'}],
        institucion_sel: null,
        departamento_sel: null,
        est_civil_sel: null,
        grado_sel: [],
        pais_sel: null,
        user:{},
        input: {
            nombres:'',
        }
      }
    },
    watch:{
        'pais_sel': function(){
            this.onlyread_ci = false;
            if(this.pais_sel && this.pais_sel.id != 1){ 
                this.departamento_sel = this.departamentos.find(x=>x.id==10)
                this.onlyread_ci = true;
            }
        }
    },
    methods:{
      async getdata(){
        this.onlyread_ci = false;
        this.loading = true;
        const res = await this.personService.getPersona(this,this.user_id)
        const d = res.data.getPersona;
        this.user = d;
        this.institucion_sel= null;
        this.departamento_sel= null;
        this.est_civil_sel= null;
        this.grado_sel= [];
        this.pais_sel= null;
        this.profesiones_sel = [];
        delete this.input.idinstitucion;
        delete this.input.profesiones;
        this.input.nombres = d.nombres;
        this.input.num_doc = d.num_doc;
        this.input.email = d.email;
        this.input.sexo = d.sexo;
        this.input.tipo = d.tipo;
        this.input.diestro = d.diestro;
        this.input.domicilio = d.domicilio;
        this.input.telefono1 = d.telefono1;
        this.input.est_civil = d.est_civil;

        this.input.pri_apellido = d.pri_apellido;
        this.input.seg_apellido = d.seg_apellido;

        const res2 = await this.personService.getInstituciones(this);
        res2.data.getInstituciones.forEach(x=>x.label = `(${x.abreviatura}) ${x.nombre}`)
        this.instituciones = res2.data.getInstituciones;
        const ins = this.user.idinstitucion;
        if(ins){
            this.institucion_sel = this.instituciones.find(x=>x.id==ins);
        }

        const tp = this.input.tipo
        if(tp!='E' && tp != 'P') this.input.tipo = 'E'

        const res3 = await this.personService.getProfesiones(this);
        this.profesiones = res3.data.getProfesiones;
        const pfs = this.user.profesiones;
        if(pfs){
            this.profesiones_sel = this.profesiones.filter(x=>pfs.some(a=>a.id==x.id))
        }

        const res4 = await this.personService.getDepartamentos(this);
        let dps = res4.data.getDepartamentos.filter(x=>x.id <= 10);
        this.departamentos = dps;
        this.departamento_sel = this.departamentos.find(x=>x.id==d.iddepartamento)
        this.est_civil_sel = this.est_civils.find(x=>x.id==d.est_civil)
        
        const res5 = await this.personService.getGrados(this);
        this.grados = res5.data.getGrados;
        const gds = this.user.grados;
        if(gds){
            window.console.log('gds',gds,this.grados);
            this.grado_sel = this.grados.filter(x=>gds.some(a=>a.nombre==x.nombre))
        }

        const res6 = await this.personService.getPaises(this);
        this.paises = res6.data.getPaises;
        this.pais_sel = this.paises.find(x=>x.id==d.idpais)

        this.loading = false;
      },

      tieneCaracteresespeciales(cadena) {
        const regex = /[ÁÉÍÓÚÑ áéíóúñ]/;
        return regex.test(cadena)
      },

      async guardar(){
        const idcargo = this.$store.state.CARGO.id;
        // window.console.log('IDDDD',idcargo);
        if(idcargo != 8 && idcargo != 1 ){
            this.$root.$notify.show('No eres digno :)', { color: 'red' });
            return;
        }
        delete this.input.idinstitucion;
        delete this.input.profesiones;
        delete this.input.idpais;
        delete this.input.iddepartamento;
        delete this.input.grados;
        delete this.input.profesiones;
        this.input.iddepartamento = null;

        if(this.institucion_sel) this.input.idinstitucion = this.institucion_sel.id;
        if(this.profesiones_sel && this.profesiones_sel.length > 0){
            this.input.profesiones = this.profesiones_sel.map(item => item.id);
        }
        if(this.profesiones_sel.length == 0){
            this.$root.$notify.show('Seleccione al menos una profesion', { color: 'red' });
            return;
        }
        if(!this.input.domicilio || this.input.domicilio.length < 5){
            this.$root.$notify.show('El domicilio debe tener mas de 5 caracteres', { color: 'red' });
            return;
        }
        if(!this.est_civil_sel){
            this.$root.$notify.show('El estado civil debe ser seleccionado', { color: 'red' });
            return;
        }

        const especiales = this.tieneCaracteresespeciales(this.input.email);
        if(especiales){
            this.$root.$notify.show('el correo no debe contener caracteres mayusculas ni tildes ni la letra ñ', { color: 'red' });
            return;
        }

        if(this.grado_sel && this.grado_sel.length > 1){
            this.$root.$notify.show('seleccione solamente el grado academico mas alto', { color: 'red' });
            return;
        }
        
        if(this.departamento_sel) this.input.iddepartamento = this.departamento_sel.id;
        if(this.pais_sel) this.input.idpais = this.pais_sel.id;
        this.input.grados = this.grado_sel.map(item => ({idgrado:item.id, titulo:item.nombre}));
        this.input.est_civil = this.est_civil_sel.id;
        const obj = window.Object.assign({}, this.input);
        obj.telefono1 = obj.telefono1.replace(/\D/g, '');

        this.loading = true;
        
        const res = await this.personService.updatePersona(this,obj);
        if(res && res.networkError && res.networkError.result){
            let msg = '';
            const es = res.networkError.result.errors;
            es.forEach(e => msg += `${e.message} `);
            this.$root.$notify.show(msg, { color: 'red' });
        }
        if(res && res.graphQLErrors){
            let msg = '';
            const es = res.graphQLErrors;
            es.forEach(e => {
                e.message.message.forEach(x=>{ 
                    msg += `${x.error} `
                })
            });
            this.$root.$notify.show(msg, { color: 'red' });
        }
        if( res && res.data){
            const r = res.data.updatePersona;
            if(r.ok) this.$root.$notify.show('Guardado', { color: 'green' });
            else {
                let msg = '';
                const es = r.errors;
                es.forEach(e => msg += `${e.message} `);
                this.$root.$notify.show(msg, { color: 'red' });
            }
        }
        window.console.log('---', JSON.stringify(res));
        this.loading = false;
      }
    },
    mounted(){
        this.user_id = this.$route.query.id; 
        if(this.user_id){
            this.input.id = parseInt(this.user_id);
        }
        this.getdata();
    }
  }
  </script>